import { render } from "./ChevronRightSvg.vue?vue&type=template&id=36a8182f"
const script = {}
script.render = render

export default script